import { render } from "./TollingPrice.vue?vue&type=template&id=381f8236"
import script from "./TollingPrice.vue?vue&type=script&lang=js"
export * from "./TollingPrice.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__